import { rei } from "@/services/api"

class RegistrosService {
  static getRegistroById (registro_id) {
    return rei.get(`registros/${ registro_id }`).then(res => res.data)
  }

  static storeRegistro (params) {
    return rei.post(`registros`, { ...params }).then(res => res.data)
  }

  static updateRegistro (registro_id, params) {
    return rei.put(`registros/${registro_id}`, { ...params }).then(res => res.data)
  }

  static deleteRegistro (registro_id, params) {
    return rei.delete(`registros/${registro_id}`, { ...params }).then(res => res.data)
  }

  static cancelRegistro (registro_id, params) {
    return rei.delete(`registros-cancelado/${registro_id}`, { params: { ...params } }).then(res => res.data)
  }

  static recordNavigation (id, tipo, operador) {
    return rei.get(`registro/navigation/${operador}?registro_id=${id}&tipo_registro=${tipo}`).then(res => res.data)
  }
  static getRegistroByTermo (termo,tipo) {
    return rei.get(`registro/termo?termo=${termo}&tipo_registro=${tipo}`).then(res => res.data)
  }

  static gerarXML (id) {
    return rei.post(`gerar-xml-segunda-via/${id}`).then(res => res.data)
  }

  /**
   * Gerador de Matrícula
   */
  static getMatricula (params) {
    return rei.post(`gerar-matricula`, { ...params }).then(res => res.data)
  }

  /**
   * Funções para Rascunhos de Registros
   * Aceita qualquer objeto, é apenas para gerenciar os rascunhos.
   */
  static getRascunhoById (rascunho_id) {
    return rei.get(`registros-rascunho/${rascunho_id}`).then(res => res.data)
  }

  static storeRascunho (params) {
    return rei.post(`registros-rascunho`, { ...params }).then(res => res.data)
  }

  static updateRascunho (rascunho_id, params) {
    return rei.put(`registros-rascunho/${rascunho_id}`, { ...params }).then(res => res.data)
  }

  static deleteRascunho (rascunho_id) {
    return rei.delete(`registros-rascunho/${rascunho_id}`).then(res => res.data)
  }

  /* Importação em Lote */
  static getRegistrosImportacaoEmLote (params) {
    return rei.get('importar-em-lote/registros', { params: params }).then(res => res.data)
  }

  static perfilRegistro (tipoLivro) {
    return rei.get('registro/perfis-ged', {params: {tipo_livro: tipoLivro}}).then(res => res.data)
  }

  static deleteRascunhoLote (ids) {
    const params = {
      ids: ids
    }

    return rei.delete(`registros-rascunho`, { params }).then(res => res.data)
  }
}

export default RegistrosService
